import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@rtls-environment/environment';
import { User } from '@rtls/core/models/human/user.model';
import { Result } from '@rtls/core/models/result.model';
import { RtlsUserService } from '@rtls/core/models/rtls/keycloak/rtls-user-service.model';
import { Observable } from 'rxjs';

@Injectable()
export class RtlsUserServiceBackend<T extends User> implements RtlsUserService<T> {
	private baseUrl = environment.usersApi;

	constructor(private _http: HttpClient) {}

	getClients(): Observable<Result<string>> {
		return this._http.get<Result<string>>(`${this.baseUrl}/external-users/clients`);
	}

	getUser(id: string) {}

	getAllUsers(): Observable<Result<User>> {
		return this._http.get<Result<User>>(`${this.baseUrl}/external-users`);
	}

	addRolesToUser(rolesIds: string[], userId: string, client: string): Observable<any> {
		return this._http.post(`${this.baseUrl}/external-users/${userId}/roles?client=${client}`, rolesIds);
	}

	getUserRoles(userId: string, client: string): Observable<any> {
		return this._http.get<User>(`${this.baseUrl}/external-users/${userId}/roles?client=${client}`);
	}

	removeRolesFromUser(rolesIds: string[], userId: string, client: string): Observable<any> {
		return this._http.request('delete', `${this.baseUrl}/external-users/${userId}/roles?client=${client}`, {
			body: rolesIds,
		});
	}

	delete(userId: string): Observable<any> {
		return this._http.delete(`${this.baseUrl}/external-users/${userId}`);
	}

	addUser(user: User): Observable<any> {
		return this._http.post<User>(`${this.baseUrl}/external-users`, user);
	}

	updateUser(userId: string, userData: User): Observable<User> {
		return this._http.put<User>(`${this.baseUrl}/external-users/${userId}`, userData);
	}
}
